module.exports = __webpack_public_path__ + "static/media/chain.635a2378.svg";